import React, { useEffect } from 'react';

import { useModalStore } from '@/store/apps/modalStore';

import { manageBodyScrollAndPadding } from '@/utils/manageBodyScrollAndPadding';

import type { ModalType } from './types';

export default function ModalContainer() {
  const { modals, isModalOpen, closeModal } = useModalStore();

  useEffect(() => {
    function pressEsc(event: any) {
      if (isModalOpen) {
        if (event.key === 'Escape') {
          modals.map((modal) => closeModal(modal.id));
        }
        return;
      }
    }
    document.addEventListener('keydown', pressEsc);
    return () => document.removeEventListener('keydown', pressEsc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  const modalHandler = (
    fn: ModalType['onClose'] | ModalType['onSubmit'],
    id: ModalType['id'],
    data?: any,
  ) => {
    fn?.(data);
    closeModal(id);
  };

  useEffect(() => {
    manageBodyScrollAndPadding(isModalOpen);
  }, [isModalOpen]);

  return (
    <div
      className={`fixed left-0 top-0 z-[10000] h-full w-full ${
        isModalOpen
          ? 'custom-scroll-modal pointer-events-auto overflow-y-auto'
          : 'pointer-events-none'
      }`}
    >
      {modals.map(
        ({
          id,
          component: ModalComponent,
          size,
          title,
          message,
          submitButtonText,
          closeButtonText,
          closeOnClickOutside = true,
          onSubmit,
          onClose,
          ...props
        }: ModalType) =>
          ModalComponent && (
            <div
              key={id}
              className="fixed left-0 top-0 flex h-full w-full items-center justify-center"
            >
              <ModalComponent
                id={id}
                size={size}
                title={title}
                message={message}
                submitButtonText={submitButtonText}
                closeButtonText={closeButtonText}
                closeOnClickOutside={closeOnClickOutside}
                modalSubmit={(data?: any) => modalHandler(onSubmit, id, data)}
                modalClose={(data?: any) => modalHandler(onClose, id, data)}
                {...props}
              />
            </div>
          ),
      )}
    </div>
  );
}
